import { AssetFields } from '../Asset/query';
export const UspItemFields = `
{
    title
    description
    icon ${AssetFields()}
}
`;
